import { Typography } from '@altibox/lte-salgskanaler-design-system-component-lib';
import { styled } from 'styled-components';

import { Container } from 'src/components/container';
import { breakpointTablet } from 'src/styles/breakpoints';
import { spacing2, spacing3, spacing7, spacing8, spacing9 } from 'src/styles/spacing';

export const StyledContainer = styled(Container)`
  margin-top: ${spacing2};
  margin-bottom: ${spacing7};

  @media (min-width: ${breakpointTablet}) {
    margin-top: ${spacing8};
    margin-bottom: ${spacing9};
  }
`;

export const StyledHeading = styled(Typography)`
  text-align: center;
  margin-bottom: ${spacing7};
`;

export const StyledButtonContainer = styled.div`
  margin: ${spacing8} auto ${spacing3};
  display: flex;
  justify-content: center;
`;

export const StyledTerms = styled(Typography)`
  text-align: center;
`;
